// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/magazzino/cruscotto?societaId&commessaId&ordineId&q',
    requestBody: null,
    response: '{"success":true,"data":[{"ordine":{"id":"number","numero":"string","dataConferma":"string|null"},"commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"clienteRagioneSociale":"string","daAllestireTotale":"number","righeMancanti":"number","righeContese":"number","righe":[{"articoloId":"number|null","codice":"string|null","descrizione":"string","tipologia":"string|null","unitaMisura":"string|null","origini":["ORDINE_VENDITA|DISTINTA"],"richiesto":"number","consegnato":"number","daAllestire":"number","inRda":"number","giacenza":"number|null","impegnatoAltriOrdini":"number|null","disponibileNetto":"number|null","copertura":"ALLESTITO|DISPONIBILE|CONTESO|PARZIALE|MANCANTE|NON_GESTITO","alternativi":[{"articoloId":"number","codice":"string","descrizione":"string","giacenza":"number"}]}]}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
